module.exports = __webpack_public_path__ + "static/media/inktoberShroomHat.10ffa33a.gif";